module.exports = __webpack_public_path__ + "static/img/stimulusConfigGray.b91366a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stimulusConfigGray.png
// module id = 7Caf
// module chunks = 1